/**
 * @generated SignedSource<<33f2110c6275cfa7e1ccb7454a2fef39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MessageFeedbackType = "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type SubmitChatFeedbackInput = {
  conversationId: any;
  feedbackTags?: ReadonlyArray<string> | null | undefined;
  feedbackText?: string | null | undefined;
  feedbackType: MessageFeedbackType;
  messageId: string;
};
export type useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation$variables = {
  input: SubmitChatFeedbackInput;
};
export type useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation$data = {
  readonly submitChatFeedback: {
    readonly success: boolean;
    readonly v1ConversationId: string | null | undefined;
    readonly v1MessageId: string | null | undefined;
    readonly v2ConversationId: string | null | undefined;
    readonly v2MessageId: string | null | undefined;
  };
};
export type useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation = {
  response: useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation$data;
  variables: useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitChatFeedbackPayload",
    "kind": "LinkedField",
    "name": "submitChatFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "v1MessageId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "v1ConversationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "v2MessageId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "v2ConversationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d025586fe2265f61083e56468c14280",
    "id": null,
    "metadata": {},
    "name": "useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation useSubmitLlmChatFeedbackMutationSubmitChatFeedbackMutation(\n  $input: SubmitChatFeedbackInput!\n) {\n  submitChatFeedback(input: $input) {\n    success\n    v1MessageId\n    v1ConversationId\n    v2MessageId\n    v2ConversationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1825361e7c3bfdc3dd93c7eed2d6098f";

export default node;
